export const tableNames = {
  ACCOUNTABILITY_SHEET: "Accountability Sheet",
  ENROLLMENT_PROCESSING: "Enrollment Processing",
};
